import { Component, OnDestroy } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { FrequencyIntervalComponent } from './frequency-interval/frequency-interval.component';
import { FrequencyOnlyComponent } from './frequency-only/frequency-only.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { Subject, takeUntil } from 'rxjs';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import { FrequencyDrawerParams } from '../../insights-data.interface';
import { DrawerService } from '../../../../../../core/services/drawer.service';
import { EnterDataSaveNextUtility } from '../enter-data-save-next.utility';

@Component({
  selector: 'app-frequency',
  standalone: true,
  imports: [
    NzTabsModule,
    FrequencyIntervalComponent,
    FrequencyOnlyComponent,
    NzButtonModule,
  ],
  templateUrl: './frequency.component.html',
  styleUrl: './frequency.component.scss',
})
export class FrequencyComponent implements OnDestroy {
  selectedTabIndex = 0;
  private readonly destroy$ = new Subject<void>();
  drawerParmas: FrequencyDrawerParams = {} as FrequencyDrawerParams;
  constructor(private readonly drawerService: DrawerService) {
    this.setupDrawerSubscription();
  }
  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }
  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<FrequencyDrawerParams>(DRAWER_IDS.FREQUENCY)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.drawerParmas = params;
          this.selectedTabIndex = this.drawerParmas.selectedRow.isFrequencyOnly
            ? 1
            : 0;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  handleSaveAndNext(nextDate: string): void {
    const updatedParams: FrequencyDrawerParams = {
      ...this.drawerParmas,
      selectedDate: nextDate,
      selectedDay: EnterDataSaveNextUtility.getDayName(nextDate),
      selectedRow: {
        id: 0,
        date: nextDate,
        day: EnterDataSaveNextUtility.getDayName(nextDate),
        individualIntervalDetails: '',
        totalFrequency: '',
        totalDuration: '',
        averageDuration: '',
        action: '',
        isFrequencyValue: false,
        isDuration: false,
        isUpdateTotal: false,
        isFrequencyOnly:
          this.drawerParmas.behaviorData?.activityDataUnitValues?.some(
            record => record.dataDate === nextDate
          ) ?? false,
        commentCount: 0,
      },
    };
    this.drawerService.setParams(DRAWER_IDS.FREQUENCY, updatedParams);
  }
}
